import { render, staticRenderFns } from "./ReporteHistorico.vue?vue&type=template&id=c1c25c34&"
import script from "./ReporteHistorico.vue?vue&type=script&lang=js&"
export * from "./ReporteHistorico.vue?vue&type=script&lang=js&"
import style0 from "./ReporteHistorico.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports